export default "__VITE_ASSET__156480c1__"